import { z } from "zod";

export default () => z.object({
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    companyName: z.string().min(1),
});